import { baseUrl } from '@/config';
//基本配置
export const config = {
  width: 1920,
  height: 1080,
  scale: 100,
  backgroundColor: '#1e1f1e',
  mark: {
    show: false,
    text: 'avue数据大屏水印',
    fontSize: 20,
    textStyle: 'rgba(100,100,100,0.2)',
    degree: -20
  },
  isWarning: false,
  warnType: 0,
  deviceList: [],
  backgroundImage: '',
  query: {}
};
// 颜色的配置
export const colorOption = {
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  column: [{
    label: '颜色1',
    prop: 'color1',
    type: 'color',
  }, {
    label: '渐变色',
    prop: 'color2',
    type: 'color',
  }, {
    label: '位置',
    prop: 'postion',
    type: 'number'
  }]
}

// 表格的列配置
export const tableOption = {
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  column: [{
    label: '名称',
    prop: 'label',
  }, {
    label: 'key值',
    prop: 'prop',
  }, {
    label: '宽度',
    prop: 'width',
  }]
}
//一些字典的配置
export const dicOption = {
  line: [{ label: '线条', value: 'line' }, { label: '圆环', value: 'circle' }],
  lineType: [{ label: '实线', value: 'solid' }, { label: '点线', value: 'dotted' }, { label: '虚线', value: 'dashed' }, { label: '混合线', value: 'blend' }],
  lineAnimation: [{ label: '水流', value: 'waterFlow' }],
  lineFlow: [{ label: '正向', value: 'positive' },{ label: '反向', value: 'reverse' }],
  fontWeight: [{ label: 'normal', value: 'normal' }, { label: 'bold', value: 'bold' }, { label: 'bolder', value: 'bolder' }, { label: 'ligter', value: 'ligter' }],
  fontFamily: [{ label: '黑体', value: 'SimHei' }, { label: '宋体', value: 'SimSun' },{ label: '微软雅黑', value: 'Microsoft YaHei' }, { label: 'Prisma', value: 'Prisma' },{ label: 'Petitinho', value: 'Petitinho' },{ label: 'HighlandGothicFLF', value: 'HighlandGothicFLF' },{ label: 'fanpaiqi', value: 'fanpaiqi' },{ label: 'Acens', value: 'Acens' },{ label: 'DS-Digital', value: 'DS-Digital' },{ label: 'DINAlternate', value: 'DINAlternate' }],
  border: [{ label: '无边框', value: '' }, { label: '内置图片', value: 'img' }, { label: '内置边框', value: 'border' }],
  textAlign: [{ label: '居中', value: 'center' }, { label: '左对齐', value: 'left' }, { label: '右对齐', value: 'right' }],
  dataType: [{ label: '静态数据', value: 0 }, { label: '动态数据', value: 1 }, {label: '设备数据', value: 2}, {label: '脚本类型', value: 3}],
  configDataType: [{ label: '历史明细', value: 0 }, { label: '历史聚合', value: 1 }, {label: '实时数据', value: 2}],
  aggregationType: [{ label: 'AVG', value: 'AVG' }, { label: 'SUM', value: 'SUM'}, {label: 'COUNT', value: 'COUNT'},{ label: 'MAX', value: 'MAX' }, {label: 'MIN', value: 'MIN'}],
  orientList: [{ label: '竖排', value: 'vertical' }, { label: '横排', value: 'horizontal' }],
  dataMethod: [{ label: 'POST', value: 'post' }, { label: 'GET', value: 'get' }],
  eventList: ['tabs'],
  sourceTypeList: [{label: 'hls', value: 'application/x-mpegURL'}, {label: 'rtmp', value: 'rtmp/mp4'}],
  mapStyleList: [{label: '标准', value: 'normal'}, {label: '幻影黑', value: 'dark'}, {label: '月光银', value: 'light'}, {label: '极夜蓝', value: 'darkblue'},
    {label: '马卡龙', value: 'macaron'},{label: '远山黛', value: 'whitesmoke'},{label: '草色青', value: 'fresh'},{label: '靛青蓝', value: 'blue'},{label: '雅士灰', value: 'grey'}],
  dataList: ['Player','common', 'text', 'wordcloud', 'img', 'tabs', 'map', 'video', 'pie', 'pictorialbar', 'iframe', 'swiper', 'flop', 'bar', 'line', 'progress', 'table', 'gauge', 'funnel', 'scatter', 'radar', 'weekSchedule'],
  deviceList: ['Player', 'text', 'gauge', 'line', 'bar', 'weekSchedule'],
  themeList: [{
    label: '默认配色',
    value: 'avue'
  }, {
    label: '紫色主题',
    value: 'macarons'
  }, {
    label: '绿色主题',
    value: 'wonderland'
  }],
  barList: ['bar', 'line'],
  titleList: ['bar', 'pie', 'line', 'radar', 'funnel'],
  labelList: ['bar', 'line', 'pie', 'radar', 'scatter'],
  legendList: ['bar', 'pie', 'line', 'radar', 'funnel'],
  colorList: ['bar', 'pie', 'line', 'funnel', 'scatter', 'radar'],
  familyList: ['gauge'],
  tipList: ['bar', 'pie', 'line', 'gauge', 'funnel', 'scatter', 'radar'],
  postionList: ['bar', 'line', 'pictorialbar'],
  formatterList: ['bar', 'map', 'line', 'pie', 'gauge', 'funnel', 'scatter', 'radar'],
  clickFormatterList: ['map'],
  labelFormatterList: ['bar'],
  tabsTypeList: [{
    label: '选项卡',
    value: 'tabs',
  }, {
    label: '选择框',
    value: 'select',
  }],
  mapType: [{
    label: '原生',
    value: 0
  }],
  target: [{ label: '本窗口', value: '_self' }, { label: '新窗口', value: '_blank', }],
  swiperType: [{ label: '普通', value: '' }, { label: '立体', value: 'card' }],
  swiperIndicator: [{ label: '外部', value: 'indicator' }, { label: '不显示', value: 'none' }],
  format: [{ label: '日期', value: 'yyyy-MM-dd' }, { label: '日期+时分', value: 'yyyy-MM-dd HH:mm' }, { label: '日期+时分秒', value: 'yyyy-MM-dd HH:mm:ss' }, { label: '日期+时分秒+星期', value: 'yyyy-MM-dd HH:mm:ss dddd' }, { label: '日期(无年)', value: 'MM-dd' }, { label: '时分', value: 'hh:mm' }, { label: '时分秒', value: 'HH:mm:ss' }, { label: '星期', value: 'day' }]
}


function concat (prop, count, type, extend = [], defaults) {
  let list = [];
  for (let i = 1; i <= count; i++) {
    list.push({
      label: prop + i,
      value: `${baseUrl}img/${prop}/${prop}${i}.${extend.includes(i) ? defaults : type}`
    })
  }
  return list;
}
//加载图片素材库
export const imgOption = [
  concat('bg', 16, 'jpg', [1, 2, 3], 'png'),
  concat('border', 16, 'png'),
  concat('source', 250, 'svg', [1, 15, 16, 20, 230, 231, 232, 233, 234, 235, 236, 237,238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260], 'png'),
  concat('banner', 10, 'png')
]
